// 获取报告方式
export const reportDeliveryMethods = {
  // 0: 'Email',
  0: '邮箱',
  1: '传真',
  2: '纸质报告快递(加30元)',
  3: '纸质报告顺丰到付',
  4: '自取',
  // 2: '特快专递（加30元）',
  // 3: '特快专递到付',
  // 4: '普通邮寄',
  // 5: '自取'
};
// 互斥选项1
export const rdGroup1 = [
  '传真',
  '邮箱'
];
// 互斥选项2
export const rdGroup2 = [
  // '特快专递（加30元）',
  // '特快专递到付',
  // '普通邮寄',
  '纸质报告快递(加30元)',
  '纸质报告顺丰到付',
  '自取'
];


// 暂不使用_委托单信息 - 检验方法
export const testingMethod = {
  0: '认可方法',
  1: '非认可方法',
  2: '认可北矿检测技术有限公司的方法'
};

// 暂不使用_委托单信息 - 特别说明
export const specInstructions = {
  0: '加急',
  1: '制样',
  2: '原样测定'
};

// 样品信息 - 样品状态
export const sampleFormConfig = {
  0: '粉（Powder）',
  1: '块状（Bulk）',
  2: '粒状（ Granular）',
  3: '湿泥（Mud）',
  4: '湿粉（Wet powder）',
  5: '液体（Liquid）',
  6: '屑（Scraps）',
  7: '粗湿粉（Wet cribble）',
  8: '无色透明液体（ Colorless liquid）',
  9: '粗粉（Cribble)',
  10: '湿盐状（Wet salt）',
  11: '固体（Solid）',
  12: '湿屑（Wet scraps）'
};

// 样品信息 - 是否选项
export const sampleTFConfig = {
  0: '原样测定',
  1: '制样（收费）',
  2: '加急（收费）',
  3: '留样（收费）'
};

// 委托方信息 - 开票类型
export const billingTypeConfig = {
  // 0: '普通发票(电子)',
  // 1: '普通发票(纸票)',
  0: '普通发票',  // 取消电子/纸质的区分后，兼容历史委托方信息展示
  1: '普通发票',
  2: '增值税专用发票',
  3: '收购发票(电子)',
  4: '收购发票(纸质)'
};

// 委托方信息 - 行业类型
export const industryTypeConfig = {
  0: '兵器(BQ)',
  1: '电子(DZ)',
  2: '核工业(HG)',
  3: '航空(HK)',
  4: '航天(HT)',
  5: '计量单位(JL)',
  6: '机械(JX)',
  7: '科技(KJ)',
  8: '科研院校(KY)',
  9: '汽车(QC)',
  10: '其他(QT)'
};

// 委托方信息 - 地域
export const regionConfig = {
  0: '东北地区',
  1: '华北地区',
  2: '华东地区',
  3: '华中地区',
  4: '华南地区',
  5: '西南地区',
  6: '西北地区',
  7: '其他地区'
};

// 委托方信息 - 客户类型
export const clientTypeConfig = {
  0: '普通客户',
  1: '预存款客户',
  2: 'VIP客户'
};

// 委托方信息 - 信用度
export const creditRatingConfig = {
  0: 'A级',
  1: 'B级',
  2: 'C级'
};

// 委托方信息 - 客户阶段
export const customerPhaseConfig = {
  0: '意向',
  1: '在检',
  2: '已流失'
};

// 委托单信息 - 委托方3与关联付款方的关系
export const relationshipConfig = [
  '上下游',
  '同事'
];

// 委托单状态
export const orderStatusConfig = {
  21: '待审核',
  22: '待确认',
  23: '待付款',
  // 24: '待确认收款',
  25: '检测中',
  26: '已完成',
  '-20': '已作废'
};

// 密码：强口令校验
export const PWD = {
  min: 8,  // 密码长度下限
  max: 20  // 密码长度上限
};
export const strongPasswordRegex = new RegExp(
  `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&]).{${PWD.min},${PWD.max}}$`
);
export const validateStrongPwd = (rule, value, cb) => {
  if(!strongPasswordRegex.test(value)) {
    cb(new Error('需要包含大小写字母、数字和特殊字符'));
  } else {
    cb();
  }
};

// 用户名校验
export const usrNameRegex = /^(?=.*[a-zA-Z])(?=.*\d).{4,12}$/;
export const checkUsrName = (rule, value, cb) => {
  if(!usrNameRegex.test(value)) {
    cb(new Error('仅包含字母和数字'));
  } else {
    cb();
  }
};



// WEBPACK FOOTER //
// ./src/config/bkjcStroeConfig.js